import { RECOMMENDATION_TYPES } from '@bingads-webui-campaign/recommendation-core';

export const RECOMMENDATION_INLINE_ACTION_TYPE = {
  APPLY_ONLY: 'apply_only',
  APPLY_EDIT: 'apply_edit',
  APPLY_PANEL_EDIT: 'apply_panelEdit',
  RESUBMIT_EDIT: 'resubmit_edit',
  EDIT_ONLY: 'edit_only',
  EXTERNAL: 'external',
  REPAIR: 'repair',
  SETUP_CONV: 'setup_conversion',
  HYBRID: 'hybrid',
  IMAGE_EXTENSION: 'image_extension',
};


export const PANEL_DECORATOR_TITLE = {
  [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: _TL_('Edit Responsive Search ads'),
  [RECOMMENDATION_TYPES.MULTIMEDIA_ADS]: _TL_('Edit Multimedia ads'),
  [RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS]: _TL_('Responsive Search ads Optimization'),
  [RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL]: _TL_('Create an event goal'),
  [RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS]: _TL_('Multimedia ads optimization'),
};

export const PANEL_WIDTH = {
  [RECOMMENDATION_TYPES.IMAGE_EXTENSION]: 1268,
  [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: 1300,
  [RECOMMENDATION_TYPES.MULTIMEDIA_ADS]: 1350,
  [RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS]: 580,
  [RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL]: 940,
  [RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS]: 1350,
};
